import { createAction } from 'redux-act'
import API from 'api'

export const request = createAction('reservation/request')
export const receive = createAction('reservation/receive')

export const authenticationRequest = (id, step, data) => (dispatch) => {
  dispatch(request({ id, step, data }))

  return API.authentication(id, step, data)
    .then(response => {
      dispatch(receive({ id, step, response }))

      return Promise.resolve(response)
    })
}
